export default [
  {
    path: '/',
    name: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/businessList',
    name: '合作商家',
    meta: {
      title: '合作商家',
      keepAlive: true
    },
    component: () => import('@/pages/businessList')
  },
  {
    path: '/login',
    name: '会员登录',
    meta: {
      title: '会员登录',
      keepAlive: true
    },
    component: () => import('@/pages/login')
  },
  {
    path: '/register',
    name: '注册',
    meta: {
      title: '注册',
      keepAlive: true
    },
    component: () => import('@/pages/register')
  },
  {
    path: '/recom',
    name: '推荐',   
    redirect: to => {
      const { hash, params, query } = to
      return { path: '/register',query:query}
    }
  },
  {
    path: '/ufindpassword',
    name: '忘记密码',
    meta: {
      title: '忘记密码',
      keepAlive: true
    },
    component: () => import('@/pages/ufindpassword')
  },
  {
    path: '/wapnfindpwdNext',
    name: 'wapnfindpwdNext',
    meta: {
      title: ''
    },
    component: () => import('@/pages/wapnfindpwdNext')
  },
  {
    path: '/regxy',
    name: '注册协议',
    meta: {
      title: '注册协议',
      keepAlive: true
    },
    component: () => import('@/pages/regxy')
  },
  {
    path: '/userCenter',
    name: '用户中心',
    meta: {
      title: '用户中心',
      keepAlive: true
    },
    component: () => import('@/pages/userCenter')
  },
  {
    path: '/news',
    name:'news',
    meta: {
      title: '个人信息',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/news')
  },  
  {
    path: '/editinfo',
    name:'editinfo',
    meta: {
      title: '修改资料',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/editinfo')
  },  
  {
    path: '/writeletter',
    name:'writeletter',
    meta: {
      title: '站内信箱',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/writeletter')
  },  
  {
    path: '/accountflow',
    name:'accountflow',
    meta: {
      title: '账户流水',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/accountflow')
  },  
  {
    path: '/bank',
    name:'bank',
    meta: {
      title: '银行',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/bank')
  },  
  {
    path: '/cashBack',
    name:'cashBack',
    meta: {
      title: '亏损返利',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/cashBack')
  },    
  {
    path: '/firstRecharge',
    name:'firstRecharge',
    meta: {
      title: '领首充',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/firstRecharge')
  },      
  {
    path: '/complain',
    name:'complain',
    meta: {
      title: '我要吐槽',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/complain')
  },  
  {
    path: '/promote',
    name:'promote',
    meta: {
      title: '推广收益',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/promote')
  },  
  {
    path: '/sign',
    name:'sign',
    meta: {
      title: '签到',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/sign')
  },
  {
    path: '/getpaid',
    name:'getpaid',
    meta: {
      title: '领工资',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/getpaid')
  },
  {
    path: '/useprops',
    name:'useprops',
    meta: {
      title: '使用道具',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/useprops')
  },
  {
    path: '/came',
    name:'came',
    meta: {
      title: '卡密管理',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/came')
  },
  {
    path: '/redemption',
    name:'redemption',
    meta: {
      title: '兑奖记录',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/redemption')
  },
  {
    path: '/changepassword',
    name:'changepassword',
    meta: {
      title: '修改密码',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/changepassword')
  },
  {
    path: '/secret',
    name:'secret',
    meta: {
      title: '密保设置',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/secret')
  },
  {
    path: '/phoneverify',
    name:'phoneverify',
    meta: {
      title: '手机验证',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/phoneverify')
  },
  {
    path: '/settings',
    name:'settings',
    meta: {
      title: '设置中心',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/settings')
  },
  {
    path: '/protect',
    name:'protect',
    meta: {
      title: '登陆地保护',
      keepAlive: true,
      requiresAuth: true
    },    
    component: () => import('@/pages/usercenter/protect')
  },
  {
    path: '/lotterylobby/:caizhongID',
    name: 'lotterylobby',
    meta: {
      keepAlive: true,
      requiresAuth: true
    },
    component: () => import('@/pages/lotteryLobby.vue')
  },
  {
    path: '/forecastrecommend/:caizhongID',
    name:'forecastrecommend',
    meta: {
      keepAlive: true,
      requiresAuth: true
    },
    component: () => import('@/pages/forecastRecommend.vue')
  },
  {
    path: '/charts/:caizhongID',
    name:'charts',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/chartsPage.vue')
  },
  {
    path: '/chartsDetail/:caizhongID',
    name:'chartsDetail',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/chartsDetail.vue')
  },    
  {
    path: '/live/:caizhongID',
    name:'live',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/live.vue')
  },
  {
    path: '/smsVerify',
    name:'smsVerify',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/smsVerify.vue')
  },  
  {
    path: '/noticeDetail/:caizhongID',
    name:'noticeDetail',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/noticeDetail.vue')
  },  
  {
    path: '/downloadCenter',
    meta: {
      keepAlive: true,
      requiresAuth: true
    },
    component: () => import('@/pages/downloadCenter.vue')
  },
  {
    path: '/cash',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/cash.vue')
  },
  {
    path: '/helpCenter',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/helpCenter.vue')
  },
  {
    path: '/help',
    meta: {
      keepAlive: true
    },
    component: () => import('@/pages/help.vue')
  },              
]



// WEBPACK FOOTER //
// ./src/config/routes.js